<template>
<div class="edit-template" v-show="edit_template">
    <ColorList :colorList="colorList" :showColorList="showColorList" :colorListValue="colorListValue" :checkDefaultValue="true" :selectedDefaultHex="selectedDefaultHex" :closeEdit="closeColorList" :canvasActiveObj="canvasActiveObject" :value="color" v-on:set-value="setColor" @undoAndRedoImageColor="saveCanvasDataInColor" @triggerLoaderGrandChild="triggerLoaderGrandChild" :vendor_colors_list="vendor_colors_list" :decorationType="decorationType" />

    <div v-show="!colorList" class="tools_headding catgory_headding w-100 add_txt heading-pd">
        <a href="#" @click="closeEdit(selectedType)" class="text_primary_blue d-flex w-100"><img src="/maincss/images/tool_back_arrow.svg" alt=" " class="mr_12" />
            <h4 class="heading5">
                Edit
                {{
                        selectedType == "clipart"
                            ? "Clipart"
                            : selectedType == "templates"
                            ? "Template"
                            : selectedType == "shape"
                            ? "Shape"
                            : selectedType == "patch"
                            ? "Patch"
                            : ""
                    }}
            </h4>
        </a>
        <a href="#" @click="closeEdit(selectedType)" title="Close" class="ml-auto"><img src="/maincss/images/tool_close.svg" alt=" " /></a>
    </div>
    <div v-show="!colorList" class="rt-edit-template">
        <div class="center_layering_filip">
            <Layering :value="layer" v-on:set-value="setLayer" />
            <Center :showLabel="true" :setClass="setClass" v-on:set-value="setCenter" />

            <Flip :value="flip" v-on:set-value="setFlip" />

            <Duplicate :setClass="setClass" v-on:set-value="addDuplicate" :value="text" />
        </div>

        <br /><br />
        <Rotation :mTop="0" :value="rotation" v-on:set-value="setRotation" />
    </div>
    <div v-show="!colorList" class="well p-0 m-0">
        <div class="form-group frm-grp-temp templ_studio bg_transparent">
            <div class="temp-color">
                <input type="text" disabled="true" required="required" placeholder="Colors" class="span2 form-control bg-transparent text_input_pad" /><!-- id="text-string" -->
            </div>
            <div class="color_boxes">
                <ColorBox v-for="(c, index) in colorListValue.length
                            ? colorListValue.length > 8
                                ? colorListValue.slice(0, 8)
                                : colorListValue
                            : [color]" :key="index" :showLabel="showLabel" :value="c" v-on:set-value="showColorList" />
                <div class="more_colors" v-show="colorListValue.length > 8">
                    <a v-on:set-value="showColorList" href="#">+{{ colorListValue.slice(8).length }}</a>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import {
    fabric
} from "fabric";
import canvas from "html2canvas";
import Duplicate from "../components/Duplicate";
import Rotation from "../components/Rotation";
import Layering from "../components/Layering";
import Flip from "../components/Flip";
import Center from "../components/Center";
import ColorBox from "../components/ColorBox";
import ColorList from "../components/ColorListV3";
const rgba2hex = (rgba) =>
    `#${rgba
        .match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/)
        .slice(1)
        .map((n, i) =>
            (i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n))
                .toString(16)
                .padStart(2, "0")
                .replace("NaN", "")
        )
        .join("")}`;
export default {
    name: "ClipSetting",
    components: {
        Rotation,
        Duplicate,
        Layering,
        Flip,
        Center,
        ColorBox,
        ColorList
    },

    data: () => {
        return {
            setClass: "to_center",
            text: "",
            stroke: "",
            fontFamily: "Arial",
            fontStyle: "",
            fontSize: 50,
            color: "#000000",
            rotation: 0,
            textAlign: "left",
            textDecoration: "",
            fontWeight: "",
            layer: "",
            flip: "",
            center: "",
            setMargineZero: "set_margine_zero",
            showLabel: false,
            colorList: false,
            colorListValue: [],
            prevAngle: 0,
            selectedDefaultHex: ""
        };
    },
    emits: ["set-value"],
    props: [
        "data",
        "edit_template",
        "selectedType",
        "closeEdit",
        "showMenu",
        "addDeleteBtn",
        "canvasActiveObject",
        "selectedObjectColors",
        "rotationAngle",
        "vendor_colors_list",
        "decorationType",
        "printAreaBond",
        "active_flip"
    ],
    watch: {
        edit_template: function (value) {
            this.colorList = false;
            if (value) this.showColorFromList();
        },
        selectedObjectColors: function () {
            this.colorList = false;
            this.showColorFromList();
        },
        data: function (newData, oldData) {
            if (JSON.stringify(newData) != JSON.stringify(oldData)) {
                this.showColorFromList();
                let {
                    text,
                    fontFamily,
                    fontStyle,
                    fontSize,
                    color,
                    rotation,
                    textAlign,
                    layer,
                    flip,
                    center,
                    textDecoration,
                    fontWeight
                } = newData;
                this.text = text;
                this.fontFamily = fontFamily;
                this.fontStyle = fontStyle;
                this.textDecoration = textDecoration;
                this.fontWeight = fontWeight;
                this.fontSize = fontSize;
                this.color = color;
                this.rotation = rotation;
                this.textAlign = textAlign;
                this.layer = layer;
                this.flip = flip;
                this.center = center;
            }
        },
        rotationAngle: function (newData, oldData) {
            if (newData != oldData) this.rotation = Math.ceil(newData);
        }
    },
    methods: {
        triggerLoaderGrandChild(currentStatus) {
            this.$emit("triggerLoader", currentStatus);
        },
        setText(value) {
            if (
                !this.text.length &&
                !this.canvasActiveObject.getActiveObject()
            ) {
                /* eslint-disable */
                var textSample = new fabric.Text("", {
                    id: new Date() / 1,
                    left: LEFT_OFFSET,
                    top: TOP_OFFSET,
                    fontFamily: "Arial",
                    angle: 0,
                    fill: "#000000",
                    fontSize: 50,
                    scaleX: 0.5,
                    scaleY: 0.5,
                    padding: 0,
                    hasRotatingPoint: true
                });
                /* eslint-enable */
                this.canvasActiveObject.add(textSample);
                this.canvasActiveObject.setActiveObject(textSample);
                var item = this.canvasActiveObject.item(
                    this.canvasActiveObject.item.length - 1
                );
                item.hasRotatingPoint = true;

                this.addDeleteBtn(item.left, item.top, item.width, item);
                // item.active = true;
            }

            this.text = value;

            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();

            if (activeObject) {
                activeObject.text = this.text;
                this.canvasActiveObject.renderAll();
                this.addDeleteBtn(
                    activeObject.left,
                    activeObject.top,
                    activeObject.width,
                    activeObject
                );
            }
        },
        enabled() {
            if (this.canvasActiveObject) {
                var activeObject = this.canvasActiveObject.getActiveObject();
                if (activeObject) {
                    return true;
                } else {
                    return false;
                }
            } else {
                return false;
            }
        },
        getActive() {
            if (this.canvasActiveObject) {
                var activeObject = this.canvasActiveObject.getActiveObject();
                if (activeObject) {
                    return "Edit Text";
                } else {
                    return "Add Text";
                }
            } else {
                return "Add Text";
            }
        },
        setFontType(value) {
            this.fontFamily = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontFamily = this.fontFamily;
                this.canvasActiveObject.renderAll();
            }
        },
        rgbToHex(rgbColorString) {
            const rgbValues = rgbColorString.match(/\d+/g);

            if (!rgbValues || rgbValues.length != 3) {
                return rgbColorString.toLowerCase();
            }

            let r = parseInt(rgbValues[0], 10); // Red value
            let g = parseInt(rgbValues[1], 10); // Green value
            let b = parseInt(rgbValues[2], 10); // Blue value

            // Ensure that the values are within the valid range (0-255)
            r = Math.max(0, Math.min(255, r));
            g = Math.max(0, Math.min(255, g));
            b = Math.max(0, Math.min(255, b));

            // Convert each component to a hexadecimal string
            const redHex = r.toString(16).padStart(2, "0");
            const greenHex = g.toString(16).padStart(2, "0");
            const blueHex = b.toString(16).padStart(2, "0");

            // Combine the hexadecimal values to form the HEX color code
            const hexCode = `#${redHex}${greenHex}${blueHex}`;

            return hexCode.toUpperCase(); // Optional: Convert to uppercase for consistency
        },
        showColorFromList() {
            /* eslint-disable */
            this.selectedObjectColors.forEach((colorHex, i) => {
                if (colorHex.includes("rgb")) {
                    this.selectedObjectColors[i] = this.rgbToHex(colorHex);
                }
            });
            /* eslint-enable */
            this.colorListValue = this.selectedObjectColors;
        },
        showColorFromListOld() {
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                this.colorListValue = [];
                var colorListValue = [];
                if (activeObject._objects && activeObject._objects.length) {
                    fabric.Object.prototype.objectCaching = false;
                    var reg = /^#([0-9a-f]{3}){1,2}$/i;
                    var matchColors =
                        /rgb\(\s*(\d{1,3})\s*,\s*(\d{1,3})\s*,\s*(\d{1,3})\s*\)$/;
                    activeObject._objects.forEach(function (e) {
                        let hexColor = "";

                        if (matchColors.exec(e.fill)) {
                            hexColor = rgba2hex(e.fill);
                        }
                        if (reg.test(e.fill) || hexColor) {
                            colorListValue.push(e.fill);
                        }
                    });
                    this.colorListValue = [...new Set(colorListValue)];
                } else {
                    this.colorListValue = [];
                }
            }
            if (activeObject.paths && activeObject.paths.length) {
                colorListValue.push(activeObject.fill);
                this.colorListValue = [...new Set(colorListValue)];
            }
        },
        showColorList(hex = null) {
            this.showColorFromList();
            this.colorList = true;
            this.selectedDefaultHex = hex;
        },
        closeColorList() {
            this.colorList = false;
        },
        setColor(value, oldColour) {
            this.color = value;
            if (!this.canvasActiveObject) {
                return;
            }
            console.log(oldColour);
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fill = this.color;
                this.colorListValue[0] = this.color;

                this.canvasActiveObject.renderAll();
            }
        },
        setOutline(value) {
            this.stroke = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.stroke = this.stroke;
                this.canvasActiveObject.renderAll();
            }
        },
        setFontStyle(value) {
            this.fontStyle = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontStyle = this.fontStyle;
                this.canvasActiveObject.renderAll();
            }
        },

        setTextDecoration(value) {
            this.textDecoration = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.textDecoration = this.textDecoration;
                this.canvasActiveObject.renderAll();
            }
        },
        setFontWeight(value) {
            this.fontWeight = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontWeight = this.fontWeight;
                this.canvasActiveObject.renderAll();
            }
        },

        setFontSize(value) {
            this.fontSize = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.fontSize = Number(this.fontSize);
                this.canvasActiveObject.renderAll();
            }
        },
        setRotation(value) {
            this.rotation = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.originX = "center";
                activeObject.originY = "center";

                if (Number(this.rotation) == 0) {
                    activeObject.angle = 0.01;
                } else {
                    activeObject.angle = Number(this.rotation);
                }
                //activeObject.setAngle(Number(this.rotation))
                let e = {
                    target: activeObject
                };
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
                this.addDeleteBtn(
                    e.target.oCoords.mtr.x,
                    e.target.oCoords.mtr.y,
                    e.target.width,
                    e.target
                );
            }
        },
        setTextAlign(value) {
            this.textAlign = value;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.textAlign = this.textAlign;
                this.canvasActiveObject.renderAll();
                this.$emit("undoAndRedo");
            }
        },

        setCenter(e) {
            if (!this.canvasActiveObject) {
                return;
            }

            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                if (e == "center") {
                    activeObject.centerH();
                    this.canvasActiveObject.renderAll();
                }
                if (e == "left" || e == "right") {
                    this.process_align(e, activeObject);
                    activeObject.setCoords();

                    this.canvasActiveObject.renderAll();
                }
                this.addDeleteBtn(
                    activeObject.oCoords.mtr.x,
                    activeObject.oCoords.mtr.y,
                    activeObject.width,
                    activeObject
                );
            }
            this.$emit("undoAndRedo");
        },

        // process_align(val, activeObj) {
        //     //  var canvas = new fabric.Canvas('c');
        //     let bound = activeObj.getBoundingRect();
        //     switch (val) {
        //         case "left":
        //             activeObj.set({
        //                 left: activeObj.left - bound.left
        //             });
        //             break;
        //         case "right":
        //             if (activeObj.angle == 0) {
        //                 activeObj.set({
        //                     left: activeObj.canvas.width - bound.width / 2 - 5
        //                 });
        //             } else {
        //                 activeObj.set({
        //                     left: activeObj.canvas.width - bound.width / 2
        //                 });
        //             }
        //             break;
        //         case "top":
        //             activeObj.set({
        //                 top: activeObj.top - bound.top
        //             });
        //             break;
        //         case "bottom":
        //             activeObj.set({
        //                 top: canvas.height - bound.height / 2
        //             });
        //             break;
        //         case "centerH":
        //             activeObj.viewportCenterH();
        //             break;
        //         case "centerV":
        //             activeObj.viewportCenterV();
        //             break;
        //     }
        //     this.$emit("undoAndRedo");
        // },

        process_align(val, activeObj) {
            let bound = activeObj.getBoundingRect();

            // Get print area boundaries
            const printArea = this.printAreaBond;

            // Calculate the offset between object center and bounding rect
            const offsetX = activeObj.left - (bound.left + bound.width / 2);
            const offsetY = activeObj.top - (bound.top + bound.height / 2);

            switch (val) {
                case "left":
                    if(this.active_flip == 'front' || this.active_flip == 'back'){
                        // Align object's left edge to print area's left edge
                        const leftCenterX = printArea.left + (bound.width / 2) + offsetX;
                        activeObj.set({
                            left: leftCenterX
                        });
                    }else{
                         activeObj.set({
                        left: activeObj.left - bound.left
                            });     
                    }    
                    break;

                case "right":
                    
                if(this.active_flip == 'front' || this.active_flip == 'back'){// Align object's right edge to print area's right edge
                    const rightCenterX = (printArea.left + printArea.width) - (bound.width / 2) + offsetX;
                    activeObj.set({
                        left: rightCenterX
                    });
                    console.log('Setting right center position to:', rightCenterX);
                }else{
                                if (activeObj.angle == 0) {
                        activeObj.set({
                            left: activeObj.canvas.width - bound.width / 2 - 5
                        });
                    } else {
                        activeObj.set({
                            left: activeObj.canvas.width - bound.width / 2
                        });
                    }
                }    
                    break;

                case "top":
                    // Align object's top edge to print area's top edge
                    const topCenterY = printArea.top + (bound.height / 2) + offsetY;
                    activeObj.set({
                        top: topCenterY
                    });
                    break;

                case "bottom":
                    // Align object's bottom edge to print area's bottom edge
                    const bottomCenterY = (printArea.top + printArea.height) - (bound.height / 2) + offsetY;
                    activeObj.set({
                        top: bottomCenterY
                    });
                    break;

                case "centerH":
                    // Center horizontally within print area
                    const centerX = printArea.left + (printArea.width / 2) + offsetX;
                    activeObj.set({
                        left: centerX
                    });
                    break;

                case "centerV":
                    // Center vertically within print area
                    const centerY = printArea.top + (printArea.height / 2) + offsetY;
                    activeObj.set({
                        top: centerY
                    });
                    break;
            }

            this.$emit("undoAndRedo");
        },
        setLayer(value) {
            var _this = this;
            _this.layer = value;
            if (!_this.canvasActiveObject) {
                return;
            }
            var activeObject = _this.canvasActiveObject.getActiveObject(),
                activeGroup = _this.canvasActiveObject.getActiveObject();
            _this.canvasActiveObject.preserveObjectStacking = true;
            if (activeObject) {
                if (_this.layer == "front") activeObject.bringToFront();
                else if (_this.layer == "back") {
                    activeObject.sendToBack();
                }
                _this.canvasActiveObject.renderAll();
            } else if (activeGroup) {
                var objectsInGroup = activeGroup.getObjects();
                _this.canvasActiveObject.discardActiveGroup();
                objectsInGroup.forEach(function (object) {
                    if (_this.layer == "front") object.bringToFront();
                    else if (_this.layer == "back") {
                        object.sendToBack();
                    }
                });
            }
            this.$emit("undoAndRedo");
        },
        saveCanvasDataInColor() {
            this.$emit("undoAndRedo");
        },
        setFlip(e) {
            // this.flip=""
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                if (e == "left") {
                    activeObject.flipX = activeObject.flipX ? false : true;
                } else if (e == "top") {
                    activeObject.flipY = activeObject.flipY ? false : true;
                }
                this.canvasActiveObject.renderAll();
            }
            this.$emit("undoAndRedo");
        },
        addDuplicate() {
            //placeText()
            let _this = this;
            if (!this.canvasActiveObject) {
                return;
            }
            var activeObject = this.canvasActiveObject.getActiveObject();
            if (activeObject) {
                activeObject.clone(function (cobj) {
                    cobj.set("top", cobj.top + 20);
                    cobj.set("left", cobj.left + 20);
                    _this.canvasActiveObject.add(cobj);
                    _this.canvasActiveObject.renderAll();
                    this.$emit("undoAndRedo");
                });
            }
        }
    }
};
</script>

<style>
.a_disabled button {
    cursor: not-allowed;
}

.to_center {
    flex-direction: column;
    display: flex;
    width: 100%;
}

.to_center>button {
    margin: auto;
}

.set_margine_zero {
    margin: 0 !important;
}

.setwidth_top_margin {
    width: 28% !important;
    margin-top: 0 !important;
}
</style>
